import { FC, useEffect, JSX } from 'react';
import {Outlet, Navigate} from 'react-router-dom';
import {AuthenticationHandler} from "../../components/auth/AuthenticationHandler";
import {useContext} from "react";


const AdminRoute = () => {
    const auth = useContext(AuthenticationHandler);
    return auth?.isAuthenticated && auth?.isAdmin ? <Outlet /> : <Navigate to="/admin-login" />;

};

export default AdminRoute;
